// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"97d2108e","55":"3023dc4e","171":"dacdb70d","429":"32f3ae98","453":"e7b0dab1","519":"8d4b60d0"}[chunkId] + ".chunk.js";
};